import { IBalances } from "../../types/balances";

export enum DrawMemberStatus {
    None = 0,
    Member = 1,
    Candidate = 2,
    Confirmed = 3,
    Winner = 4,
    Finished = 5,
    Expired = 6,
}

export enum DrawMethod {
    Interactive = 1,
    Automatic = 2,
}

export enum DrawType {
    Regular = 1,
    Rare = 2,
    Epic = 3,
    Legendary = 4,
}

export interface IDraw {
    drawId: number;
    cost: IBalances;

    method: DrawMethod;
    type: DrawType;

    membersCount: number;
    confirmMinutesPeriod: number;

    prizeName: string;
    prizeCount: number;

    operDate: number;
    confirmTimeoutDate: number;
    userStatus: DrawMemberStatus;
    userWeight: number;
}